"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTTP = void 0;
const db_mapper_1 = __importDefault(require("../base/db-mapper"));
const token_model_1 = __importDefault(require("./token.model"));
var HTTP;
(function (HTTP) {
    HTTP["PUT"] = "PUT";
    HTTP["POST"] = "POST";
    HTTP["DELETE"] = "DELETE";
    HTTP["GET"] = "GET";
    HTTP["PATCH"] = "PATCH";
})(HTTP = exports.HTTP || (exports.HTTP = {}));
class TokenMapper extends db_mapper_1.default {
    async getPolicyDocumentFromTokenID(ID, methodArn, urls) {
        const token = await this.load(ID);
        if (!token || token.isExpired()) {
            return this.getPolicyDocument(ID, [], '*');
        }
        return this.generateTokenPolicyDocument(token, methodArn, urls);
    }
    getPolicyDocument(principalId, allowResources = [], denyResources = []) {
        return {
            principalId,
            policyDocument: {
                Version: '2012-10-17',
                Statement: [
                    {
                        Action: 'execute-api:Invoke',
                        Effect: 'Allow',
                        Resource: allowResources,
                    },
                    {
                        Action: 'execute-api:Invoke',
                        Effect: 'Deny',
                        Resource: denyResources,
                    }
                ],
            },
        };
    }
    replacePathParameters(token, url) {
        return url.split('/').map(urlPart => {
            if (urlPart.match(/{[A-Za-z]*}/)) {
                const pathParameter = urlPart.substring(1, urlPart.length - 1);
                return token.hasOwnProperty(pathParameter) ? token[pathParameter] : '*';
            }
            return urlPart;
        }).join('/');
    }
    generateTokenPolicyDocument(token, methodArn, urls) {
        const arnParts = methodArn.split(':');
        const apiGatewayArn = arnParts[5].split('/');
        const awsAccountId = arnParts[4];
        const region = arnParts[3];
        const restApiId = apiGatewayArn[0];
        const stage = apiGatewayArn[1];
        const baseResource = `arn:aws:execute-api:${region}:${awsAccountId}:${restApiId}/${stage}/`;
        //By default allow GETs 
        const allowResources = [`${baseResource}${HTTP.GET}/companies/${token.companyID}/*`];
        const denyResources = [];
        if (token.permissions.includes('*')) {
            allowResources.push(`${baseResource}${HTTP.POST}/companies/${token.companyID}/*`, `${baseResource}${HTTP.PUT}/companies/${token.companyID}/*`, `${baseResource}${HTTP.DELETE}/companies/${token.companyID}/*`, `${baseResource}${HTTP.PATCH}/companies/${token.companyID}/*`);
        }
        else {
            urls.forEach(urlPermission => {
                const hasPermission = urlPermission.permissions.find(perm => perm === '*' || token.permissions.find(tokenperm => tokenperm === perm || `${perm.split('.')[0]}.*` === tokenperm));
                const resourceURL = this.replacePathParameters(token, `${baseResource}${urlPermission.method}/${urlPermission.path}`);
                if (hasPermission) {
                    console.log('Allow', urlPermission.path, 'with permission', hasPermission);
                    allowResources.push(resourceURL);
                }
                else {
                    console.log('Deny', urlPermission.path, 'with permission', hasPermission);
                    denyResources.push(resourceURL);
                }
            });
        }
        const policy = this.getPolicyDocument(token.ID, allowResources, denyResources);
        return Object.assign(Object.assign({}, policy), { context: token.flatten() });
    }
}
exports.default = (config) => db_mapper_1.default.registerModel('token', token_model_1.default, TokenMapper, config)();
